import { ButtonSubmit } from '#pages/WeeklyCalenderScheduleRegistration/styles';
import { useDashboardChartFormProcess } from '../hooks/useDashboardChartFormProcess';

interface SubmitButtonProps {
  isEdit?: boolean;
}
export const SaveButton = ({ isEdit }: SubmitButtonProps) => {
  const { save, edit } = useDashboardChartFormProcess();

  const onSubmit = () => {
    if (isEdit) {
      // 수정
      edit();
    } else {
      save();
    }
  };

  // onSubmit 버튼 활성화 여부
  const disabled = false;

  return (
    <ButtonSubmit onClick={onSubmit} disabled={disabled}>
      {isEdit ? '수정' : '임시저장'}
    </ButtonSubmit>
  );
};
